'use strict';

/**
 * @ngdoc function
 * @name scrapQcrmApp.controller:DeclinedCtrl
 * @description
 * # AboutCtrl
 * Controller of the scrapQcrmApp
 */
angular.module('scrapQcrmApp')
    .controller('RejectedCtrl', function($scope, tableState, $moment, $uibModal, $global, dashboard, SellNow, ngTableParams, $log, $stateParams, agentAppointments) {
        $scope.date = {
            startDate: $moment($stateParams.fromdate,'DD-MMM-YYYY').toDate(),
            endDate: $moment($stateParams.todate,'DD-MMM-YYYY').toDate()
        };
        $scope.opts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "DD-MMM-YYYY",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')]
            }
        };
        $scope.setStartDate = function() {
            $scope.date.startDate = moment().subtract(4, "days").toDate();
        };

        $scope.setRange = function() {
            $scope.date = {
                startDate: moment().subtract(5, "days"),
                endDate: moment()
            };
        };
        // the API lists the requests of one city: send the login city (without it the list was always empty)
        $scope.vm = { params: { city: ($global.getLocalItem("loginData", true) || {}).city } };
        $scope.currentPage = 1;
        $scope.transactionChange = function() {
            $scope.totalAgentRecords = 0;
            $scope.currentPage = 1;
            $scope.vm.params.page = 0;
            $scope.vm.params.todate = $moment($scope.date.endDate).format('DD-MMM-YYYY');
            $scope.vm.params.fromdate = $moment($scope.date.startDate).format('DD-MMM-YYYY');
            $scope.vm.params.status = 'REJECTED_BY_AGENT';
            $scope.rejected($scope.vm.params);
        };
        // keep the dates, the search and the table (page, sort) in the URL, so Back / refresh show the same view
        tableState.page($scope, 'r', {
            controls: {
                d: { model: 'date', type: 'daterange', always: true },
                q: { model: 'searchText', type: 'string', history: 'search' }
            },
            dataTables: { t: 'table[datatable]' }
        });
        //Watch for date changes
        $scope.$watch('date', function(newDate) {

            $scope.transactionChange();

        }, false);

        $scope.pageChanged = function(currentPage) {
            $scope.pageNumber = currentPage - 1;
            $scope.vm.params.page = $scope.pageNumber;
            $scope.rejected($scope.vm.params);
        }
        $scope.rejected = function(params) {
            SellNow.pendingRequests(params).then(function(res) {
                $scope.totalAgentRecords = res.data.totalRecords;
                $scope.rejectedSells = res.data.sells;

            });
        };

        $scope.nextDate = function() {
            $scope.date = {
                startDate: moment($scope.date.endDate).add(1, "days"),
                endDate: moment($scope.date.endDate).add(1, "days")
            };
            // $scope.transactionChange();
        }
        $scope.previousDate = function() {
            $scope.date = {
                startDate: moment($scope.date.startDate).subtract(1, "days"),
                endDate: moment($scope.date.startDate).subtract(1, "days")
            };
            // $scope.transactionChange();
        }

        $scope.OpenRequest = function(pickup) {
            var pickupInstance = $uibModal.open({
                templateUrl: 'views/consumer-pickups-modal.html',
                controller: 'ConsumerPickupsModalCtrl',
                size: "lg",
                resolve: {
                    items: function() {

                        return pickup;
                    }
                }
            });

            pickupInstance.result.then(function(selectedItem) {
                $scope.selected = selectedItem;
            }, function() {
                $log.info('Modal dismissed at: ' + new Date());
                $scope.vm.params.page = 0;
                $scope.vm.params.todate = $moment($scope.date.endDate).format('DD-MMM-YYYY');
                $scope.vm.params.fromdate = $moment($scope.date.startDate).format('DD-MMM-YYYY');
                $scope.vm.params.status = 'REJECTED_BY_AGENT';
                $scope.declined($scope.vm.params);
            });
        }
    });
